"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { getRingbaCampaignSrc } from "@/utils/ringbaCampaign";

export default function RingbaCampaignScript() {
  const pathname = usePathname();
  const src = getRingbaCampaignSrc(pathname);

  return <Script key={src} src={src} strategy="lazyOnload" async />;
}
